import { render, staticRenderFns } from "./GridEvaluacionRelator.vue?vue&type=template&id=ab3181e0&"
import script from "./GridEvaluacionRelator.vue?vue&type=script&lang=js&"
export * from "./GridEvaluacionRelator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports